import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "src/app/shared/shared.module";

import { CreatePromptStepComponent } from "./create-prompt-step/create-prompt-step.component";
import { CreateResultStepComponent } from "./create-result-step/create-result-step.component";
import { CreateStructureStepComponent } from "./create-structure-step/create-structure-step.component";
import { CreateAiFlashcardsComponent } from "./create-ai-flashcards.component";

@NgModule({
  declarations: [
    CreateAiFlashcardsComponent,
    CreatePromptStepComponent,
    CreateResultStepComponent,
    CreateStructureStepComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ControlsModule,
    SharedModule
  ],
  exports: [
    CreateAiFlashcardsComponent,
    CreatePromptStepComponent,
    CreateResultStepComponent
  ]
})
export class CreateAiFlashcardsModule {}